import qs from "qs";
import createApiServices from "./createApiServices";
import { extendUrl3D } from "../../views/helpers/extenent-url";

const prefixURL = `${extendUrl3D.url}/api/order` || 'https://tool3d-staging.merchize.com/api/order'

const api = createApiServices({ baseUrl: prefixURL})

export const getListPartner = (data) => {
    return api.makeAuthRequest({
        url: `/partners`,
        method: 'GET',
        params: data,
    })
}

export const getItemProgress = async (batchItem) => {
    return api.makeAuthRequest({
        url: `/orders/item-progress/${batchItem}`,
        method: 'GET'
    })
}

// Báo cáo NG rate (tab Kiểm soát chất lượng)
export const getNgRateMeta = () => {
    return api.makeAuthRequest({
        url: '/report/ng-rate/meta',
        method: 'GET',
    })
}

export const getNgRateTab = (tab, params = {}) => {
    const query = qs.stringify(params, {skipNulls: true, arrayFormat: 'comma'})

    return api.makeAuthRequest({
        url: `/report/ng-rate/tabs/${tab}${query ? `?${query}` : ''}`,
        method: 'GET',
    })
}
